export enum ModuleEnum {
  AdminReports = "AdminReports",
  Admission = "Admission",
  AuditReports = "AuditReports",
  BillReports = "BillReports",
  Dashboard = "Dashboard",
  ICU = "ICU",
  LabEquipment = "LabEquipment",
  LabReports = "LabReports",
  LabRequests = "LabRequests",
  LabResults = "LabResults",
  MasterList = "MasterList",
  Maternity = "Maternity",
  Modules = "Modules",
  OPD = "OPD",
  PatientBills = "PatientBills",
  PatientReports = "PatientReports",
  PharmReports = "PharmReports",
  PharmStock = "PharmStock",
  Prescriptions = "Prescriptions",
  Registration = "Registration",
  Roles = "Roles",
  Users = "Users",
  Workflow = "Workflow",
}
export enum AppActionEnum {
  Create = "Create",
  View = "View",
  Update = "Update",
  Delete = "Delete",
  Confirm = "Confirm",
  Attest = "Attest",
  Approve = "Approve",
  Query = "Query",
  Reject = "Reject",
}

export enum transactionStatusEnum {
  Approved = 5,
  Attested = 4,
  Completed = 8,
  Created = 1,
  Queried = 6,
  Rejected = 7,
  Submitted = 2,
  Verified = 3,
}

export enum transactionEnum {
  Admission = 3,
  ICU = 2,
  OPD = 1,
}

export enum pageEnum {
  HomePage = 1,
  OPD = 2,
  Employee = 3,
  ConsultingRoom = 4,
}

export enum masterListEnum {
  Gender = 1,
  StaffType = 2,
}
